// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3v1v0","title":"ClientCherryInfo_title__27qsI","itemText":"ClientCherryInfo_itemText__3bR5T"};